import { Badge, Button } from '@sgme/ui';
import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';

import { useActions } from './hooks';

import './index.css';

export function Footer() {
  const {
    selectedRowsCnt,
    deleteSelectedRows,
    sendOperation,
    availableOperations,
    orderType,
    resetSelectedRows,
    validRowsByOperation,
  } = useActions();

  return (
    selectedRowsCnt > 0 && (
      <div
        className="bg-info bg-lvl4 p-2 d-flex justify-content-between align-items-center secondary-batch-footer"
        role="region"
        aria-label="Footer"
      >
        <span>
          <span className="badge badge-primary-alt mx-2 rounded-pill">{selectedRowsCnt}</span>selected
        </span>
        <div className="d-flex gap-2 align-items-center">
          {availableOperations
            ?.filter(
              operation =>
                operation.type === 'open-in-secondary-market' || operation.type === 'open-in-order-modification-screen',
            )
            .map(operation => (
              <Button
                key={operation.type}
                purpose="flat"
                disabled={!operation.enabled}
                onClick={() => sendOperation?.(operation.type)}
                size="lg"
                iconPosition="end"
                color="primary-alt"
              >
                <FormattedMessage id={`secondary-market-batch.${orderType}.operation.${operation.type}` as IntlKey} />
                <i className="icon icons-sm">launch</i>
              </Button>
            ))}

          <div className="vertical-divider"></div>

          <Button purpose="flat" onClick={deleteSelectedRows} size="lg" color="primary-alt" className="flex gap-2">
            <FormattedMessage id="secondary-market-batch.remove-rows" />
            <Badge color="primary-alt" purpose="outline" isPill size="md">
              {selectedRowsCnt}
            </Badge>
          </Button>
          <Button purpose="flat" onClick={resetSelectedRows} size="lg" color="primary-alt" className="flex gap-2">
            <FormattedMessage id="secondary-market-batch.reset-rows" />
            <Badge color="primary-alt" purpose="outline" isPill size="md">
              {selectedRowsCnt}
            </Badge>
          </Button>

          {availableOperations
            ?.filter(
              operation =>
                operation.type !== 'open-in-secondary-market' && operation.type !== 'open-in-order-modification-screen',
            )
            .map(operation => (
              <Button
                key={operation.type}
                purpose="primary"
                disabled={!operation.enabled}
                onClick={() => sendOperation?.(operation.type)}
                size="lg"
                iconPosition="end"
                color="primary-alt"
              >
                <FormattedMessage id={`secondary-market-batch.${orderType}.operation.${operation.type}` as IntlKey} />
                {validRowsByOperation[operation.type] && (
                  <Badge color="primary" purpose="outline" isPill size="md">
                    {validRowsByOperation[operation.type]}
                  </Badge>
                )}
              </Button>
            ))}
        </div>
      </div>
    )
  );
}
